import { CanvasOptions } from 'src/app/model/canvas-options'

export const CANVAS_OPTIONS: any = {
    activeZone:{
        name:null,
        id:null,
    },
    grid:true,
    align:true,
    imageOffset:{left:0,top:0},
    background:null,
    image:null,
    imageMetersPerPx:null,
    map: {
        show: false,
        lat:null,
        lng:null,
        zoom:null,
        metersPerPx : null

    }
}

